export default (value: string | null) => {
  const emailRegEx =
    /^(?=[A-Z0-9][A-Z0-9@._%+-]{5,253}$)[A-Z0-9._%+-]{1,64}@(?:(?=[A-Z0-9-]{1,63}\.)[A-Z0-9]+(?:-[A-Z0-9]+)*\.){1,8}[A-Z]{2,63}$/gi

  if (value && !value.match(emailRegEx)) {
    return "Email address is invalid"
  }

  return true
}
